import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import cx from 'clsx';
import PropTypes from 'prop-types';
import LogoCircleImg from '../assets/images/coral-new-logo.svg';
import logo from '../assets/images/new-logo.svg';

const StyledLogo = styled('img')(({ theme }) => ({
  display: 'flex',
  width: '150px',
  color: theme.palette.primary.dark,
  fontWeight: 'bold',
  fontSize: '22px',
  margin: '0 auto',
  height: 'auto',
  '&.drawerClose': {
    display: 'none',
  },
}));
const LogoCircle = styled('img')(({ theme }) => ({
  display: 'flex',
  color: theme.palette.primary.dark,
  fontWeight: 'bold',
  fontSize: '22px',
  width: '30px',
  height: 'auto',
  margin: '0 auto',
  '&.drawerOpen': {
    display: 'none',
  },
}));
const Root = styled(RouterLink)(({ theme }) => ({
  flexGrow: 1,
  flexDirection: 'row',
}));

function Logo({ sideMenu }) {
  return (
    <Root to="/">
      <LogoCircle
        className={cx({
          drawerOpen: sideMenu,
          drawerClose: !sideMenu,
        })}
        alt="LogoCircle"
        src={LogoCircleImg}
      />

      <StyledLogo
        className={cx({
          drawerOpen: sideMenu,
          drawerClose: !sideMenu,
        })}
        alt="Logo"
        src={logo}
      />
    </Root>
  );
}

Logo.propTypes = {
  sideMenu: PropTypes.bool.isRequired,
};

export default Logo;
